import { render, staticRenderFns } from "./profit.vue?vue&type=template&id=6bce26c0&scoped=true"
import script from "./profit.vue?vue&type=script&lang=js"
export * from "./profit.vue?vue&type=script&lang=js"
import style0 from "./profit.vue?vue&type=style&index=0&id=6bce26c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bce26c0",
  null
  
)

export default component.exports